// NoteTab.tsx
import React from 'react';
import { ILegaltransactionNote } from '../../Interfaces/ILegaltransactionNote';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { NoteRow } from './NoteRow';

export interface IProps {
  notesArray: ILegaltransactionNote[];
  setNotesArray: React.Dispatch<React.SetStateAction<ILegaltransactionNote[]>>;
}

const getEmptyNote = (notesArray: ILegaltransactionNote[]) => {
  let tmpId = -1;

  if (notesArray.length > 0) {
    const minId = Math.min(...notesArray.map(x => x.idLegalTransactionNote));
    if (minId <= tmpId) {
      tmpId = minId - 1;
    }
  }

  return {
    idLegalTransaction: -1,
    idLegalTransactionNote: tmpId,
    idUser: Number(localStorage.getItem('idUser')) || -1,
    Note: '',
    Created_at: new Date().toISOString(),
    FirstName: 'Ich',
    LastName: '',
    isEdited: false,
  } as ILegaltransactionNote;
};

export const NoteTab: React.FC<IProps> = ({ notesArray, setNotesArray }) => {
  const handleNew = () => {
    setNotesArray(prev => [getEmptyNote(prev), ...prev]);
  };

  return (
    <>
      <Typography sx={{ mt: 5 }} variant='h6'>
        Notizen
        <Button variant='outlined' sx={{ float: 'right' }} onClick={handleNew}>
          Neue Notiz
        </Button>
      </Typography>

      <Box sx={{ width: '100%', overflowX: 'auto' }}>
        <Table size='small' sx={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell width={'15%'}>Datum</TableCell>
              <TableCell width={'15%'}>Von</TableCell>
              <TableCell
                width={'50%'}
                sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
              >
                Notiz
              </TableCell>
              <TableCell width={'10%'}></TableCell>
              <TableCell width={'10%'}>Aktionen</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {notesArray.map(note => (
              <NoteRow
                key={`note-${note.idLegalTransactionNote}`}
                note={note}
                setNoteArray={setNotesArray}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </>
  );
};
